import { DynamicProcessFormProvider } from "./ui/dynamic-process-form-provider/dynamic-process-form-provider";
import { DynamicProcessTriggerForm } from "./ui/dynamic-process-trigger-form";
import { DynamicProcessTabs } from "./ui/tabs/dynamic-process-tabs";
import { SubmitWrapper } from "@/shared/form/button";
import { useDynamicModelToEdit } from "./model/use-dynamic-model-to-edit";
import { DYNAMIC_PROCESS_FORM } from "./ui/dynamic-process-form-provider/forms-enum";
import { InitiatorTemplateForm } from "./ui/initiator-template-form/initiator-template-form";
import { ApproverTemplateForm } from "./ui/approver-template-form/approver-template-form";
import { GeneralForm } from "./ui/general-form/general-form";
import { PathForm } from "./ui/path-form/path-form";
import { ModelIdProvider } from "./model/model-id/model-id-provider";
import { DynamicAttributesForm } from "./ui/dynamic-attributes-form/dynamic-attributes-form";

export function SaveDynamicProcessModel({
  modelId,
  afterSubmit,
}: {
  modelId?: string;
  afterSubmit: () => void;
}) {
  const { model } = useDynamicModelToEdit({ modelId });

  const saveAndClose = (
    <DynamicProcessTriggerForm
      name={DYNAMIC_PROCESS_FORM.TRIGGER}
      afterSubmit={afterSubmit}
    />
  );

  return (
    <ModelIdProvider modelId={modelId}>
      <DynamicProcessFormProvider>
        <DynamicProcessTabs.Provider>
          {({ setStep }) => (
            <DynamicProcessTabs
              base={
                <div>
                  <GeneralForm model={model} />

                  <SubmitWrapper>
                    {modelId ? (
                      saveAndClose
                    ) : (
                      <DynamicProcessTabs.Button
                        next
                        step={DynamicProcessTabs.ENUM.PATH_KEY}
                      />
                    )}
                  </SubmitWrapper>
                </div>
              }
              path={
                <div>
                  <PathForm model={model} />

                  <SubmitWrapper className="gap-x-2">
                    {modelId ? (
                      saveAndClose
                    ) : (
                      <>
                        <DynamicProcessTabs.Button
                          prev
                          step={DynamicProcessTabs.ENUM.BASE_KEY}
                        />
                        <DynamicProcessTabs.Button
                          next
                          step={DynamicProcessTabs.ENUM.TEMPLATES_KEY}
                        />
                      </>
                    )}
                  </SubmitWrapper>
                </div>
              }
              templates={
                <>
                  <InitiatorTemplateForm model={model} />
                  <ApproverTemplateForm model={model} />

                  <SubmitWrapper className="gap-x-2">
                    {modelId ? (
                      saveAndClose
                    ) : (
                      <>
                        <DynamicProcessTabs.Button
                          prev
                          step={DynamicProcessTabs.ENUM.PATH_KEY}
                        />
                        <DynamicProcessTriggerForm
                          name={DYNAMIC_PROCESS_FORM.TRIGGER}
                          afterSubmit={() => {
                            setStep(
                              DynamicProcessTabs.ENUM.DYNAMIC_ATTRIBUTES_KEY,
                            );
                          }}
                        />
                      </>
                    )}
                  </SubmitWrapper>
                </>
              }
              dynamicAttribute={<DynamicAttributesForm />}
            />
          )}
        </DynamicProcessTabs.Provider>
      </DynamicProcessFormProvider>
    </ModelIdProvider>
  );
}
